module.exports = __webpack_public_path__ + "static/media/36.afd773fe.svg";